import { GenericManageSubscription } from "components/settings/shared/subscription/manage-subscription";

export const UserManageSubscription = () => {
  return <GenericManageSubscription isUser={true} />;
};
